<script setup>
import RoundedButton from "@/components/global-themed/buttons/RoundedButton";
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";
import {useStore} from "vuex";
import {computed} from "vue";

const emit = defineEmits(['showTiers']);
const store = useStore();

const loading = computed(() => store.getters['agencyWebsite/loading']);

const props = defineProps({
  product: {
    type: Object,
    required: true,
  },
  description: {
    type: String,
    required: true,
  },
  alternateHasDiscount: {
    type: Boolean,
    required: true,
  },
  inclusions: {
    type: Array,
    required: true,
  },
});

const handleSubmit = async() => {
    await store.dispatch('agencyWebsite/create', props.product.id);
}
</script>

<template>
  <div
    class="tw-border-2 tw-border-grey-mid tw-flex tw-flex-col tw-gap-y-8 tw-p-12 tw-rounded-lg tw-max-w-[380px] md:tw-w-1/2 tw-w-full"
  >
    <div
      v-if="product.discountPrice"
      class="tw-h-11 tw-bg-everest-lightest tw-rounded-full tw-py-2 tw-px-4 tw-leading-loose -tw-mb-6 tw-text-everest-bright tw-font-semibold tw-flex tw-items-center tw-space-x-2 tw-justify-center"
    >
      <svg-vue
        icon="icons/airline-ticket"
        class="tw-h-6 tw-w-6"
      />
      <span>Coupon Applied</span>
    </div>

    <div
      v-if="alternateHasDiscount"
      class="tw-h-11 -tw-mb-6"
    />

    <div class="tw-text-sm tw-flex tw-flex-col">
      <span>
        <span
          v-if="product.discountPrice"
          class="tw-font-bold tw-text-xl tw-text-grey-light tw-line-through tw-mr-2"
          v-text="product.price"
        />
        <span
          class="tw-font-bold tw-text-3xl tw-text-grey-dark"
          v-text="product.discountPrice ? product.discountPrice : product.price"
        />
        /month
      </span>

      <span
        v-if="discountPriceIncVat || product.priceIncVat"
        v-text="product.discountPriceIncVat ? discountPriceIncVat : product.priceIncVat"
      />
    </div>

    <span class="tw-text-2xl tw-text-grey-dark">
      {{ product.name }}
    </span>

    <span>
      {{ description }}
    </span>

    <RoundedButton
      class="tw-mx-auto"
      variant="outline"
      @click="emit('showTiers')"
    >
      {{ product.tierLabel }}
      <svg-vue
        icon="icons/arrow-right"
        class="tw-ml-2 tw-h-6 tw-w-6"
      />
    </RoundedButton>

    <div
      v-for="(inclusion, index) in inclusions"
      :key="index"
      class="tw-flex tw-flex-col tw-gap-4 tw-flex-1 tw-text-left"
    >
      <div class="tw-flex tw-gap-2 tw-items-center tw-justify-start">
        <div
          class="tw-px-2 tw-py-2 tw-rounded-full"
          :class="[
            inclusion.ticked ? 'tw-bg-blue-highlight' : 'tw-bg-grey-mid'
          ]"
        >
          <svg-vue
            icon="icons/tick"
            class="tw-h-3 tw-w-3 tw-stroke-2"
            :class="[
              inclusion.ticked ? 'tw-text-blue': 'tw-text-slate-300'
            ]"
          />
        </div>
        <span class="tw-font-bold tw-text-grey-dark">{{ inclusion.description }}</span>
      </div>
    </div>

    <DefaultButton
      class="tw-mt-4"
      :disabled="loading"
      @click="handleSubmit"
    >
      Get Started
    </DefaultButton>
  </div>
</template>
